import dayjs from "dayjs";
import Joi from "joi";

const StoreSchema = Joi.object({
  item: Joi.string().trim().required().messages({
    "string.empty": "Item is required.",
    "any.required": "Item is required.",
  }),
  company: Joi.string().trim().required().messages({
    "string.empty": "Company is required.",
    "any.required": "Company is required.",
  }),
  supplier: Joi.string().trim().required().messages({
    "string.empty": "Supplier is required.",
    "any.required": "Supplier is required.",
  }),
  batchNo: Joi.string().trim().required().messages({
    "string.empty": "Batch Number is required.",
    "any.required": "Batch Number is required.",
  }),
  serialNo: Joi.string().trim().required().messages({
    "string.empty": "Serial Number is required.",
    "any.required": "Serial Number is required.",
  }),
  expiryDate: Joi.custom((value, helpers) => {
    if (!dayjs(value).isValid()) {
      return helpers.error("any.invalid");
    }
    return value;
  })
    .required()
    .messages({
      "any.invalid": "Expiry Date must be a valid date.",
      "any.required": "Expiry Date is required.",
    }),
  quantity: Joi.number().min(1).required().messages({
    "number.base": "Quantity must be a number.",
    "number.min": "Quantity must be at least 1.",
    "any.required": "Quantity is required.",
  }),
  purchaseRate: Joi.number().min(0).required().messages({
    "number.base": "Purchase Rate must be a number.",
    "number.min": "Purchase Rate cannot be negative.",
    "any.required": "Purchase Rate is required.",
  }),
  hospitalRate: Joi.number().min(0).required().messages({
    "number.base": "Hospital Rate must be a number.",
    "number.min": "Hospital Rate cannot be negative.",
    "any.required": "Hospital Rate is required.",
  }),
  mrp: Joi.number().min(0).required().messages({
    "number.base": "MRP must be a number.",
    "number.min": "MRP cannot be negative.",
    "any.required": "MRP is required.",
  }),
}).unknown(true);

export default StoreSchema;
